import { Component, input, output, model, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { RuleService } from '../../services/rule.service';
import Swal from 'sweetalert2';
import { FormMode } from 'app/core/constants/form-mode';

@Component({
    selector: 'app-rule-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './rule-form.component.html'
})
export class RuleFormComponent {

    ruleForm = input.required<FormGroup>();
    formChange = output<FormGroup>();
    mode = model<FormMode>(FormMode.CREATE);
    formMode = FormMode;

    private ruleService = inject(RuleService);

    constructor() {
    }

    submit() {
        if (this.ruleForm() && this.ruleForm().valid) {
            this.formChange.emit(this.ruleForm());
        }
    }


}
